const colors = {
  primary: '#2196F3',
  primary100: '#C8E6C9',
  primary300: '#64B5F6',
  primary500: '#2196F3',
  primary700: '#1976D2',
  primary900: '#0D47A1',
  grey100: '#CFD8DC',
  grey300: '#90A4AE',
  grey500: '#607D8B',
  grey700: '#455A64',
  grey900: '#263238',
};

export default colors;
